// src/features/team/Team.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Team.scss";

// optional placeholder image if no backend photo exists
import fallbackImg from "../../assets/md.jpeg";

const API_BASE = "https://api.ainfotech.com.np";

export default function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancel = false;

    const fetchTeam = async () => {
      try {
        setLoading(true);
        setErr("");
        const res = await axios.get(`${API_BASE}/api/team?page=1&limit=1000`, {
          withCredentials: true,
        });
        const list = Array.isArray(res.data?.items)
          ? res.data.items
          : Array.isArray(res.data)
          ? res.data
          : [];
        if (!cancel) setMembers(list);
      } catch (e) {
        if (!cancel) setErr(e.response?.data?.error || e.message);
      } finally {
        if (!cancel) setLoading(false);
      }
    };

    fetchTeam();
    return () => {
      cancel = true;
    };
  }, []);

  return (
    <section className="avena-team" id="team">
      <div className="container">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <h2 className="avena-team__title">
              Our Board of <span>Management</span>
            </h2>
            <p className="avena-team__subtitle">
              We design secure software and dependable hardware—planned,
              deployed, and supported by a hands-on engineering team.
            </p>
          </div>
        </div>

        {/* States */}
        {loading && (
          <div className="row">
            <div className="col-12">
              <div className="avena-team__loading">Loading team…</div>
            </div>
          </div>
        )}

        {err && !loading && (
          <div className="row">
            <div className="col-12">
              <div className="avena-team__error">{err}</div>
            </div>
          </div>
        )}

        {!loading && !err && members.length === 0 && (
          <div className="row">
            <div className="col-12">
              <div className="avena-team__empty">No team members yet.</div>
            </div>
          </div>
        )}

        {/* Grid */}
        {!loading && !err && members.length > 0 && (
          <div className="row g-4 g-xl-5 avena-team__grid">
            {members.map((m) => {
              const imgSrc = m.image ? `${API_BASE}${m.image}` : fallbackImg;
              return (
                <div className="col-12 col-md-6 col-lg-4" key={m.id}>
                  <article className="avena-team__card">
                    <div className="avena-team__media">
                      <img src={imgSrc} alt={m.name} loading="lazy" />
                    </div>
                    <div className="avena-team__body">
                      <h3 className="avena-team__name">{m.name}</h3>
                      <p className="avena-team__role">{m.designation}</p>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
